import { ExposureControlType, GuardFeatures, IFeatureValue } from './ec.typings';

export const nonTridentEcFeatures: IFeatureValue[] = [
    {
        featureName: GuardFeatures.ADFRerunTWTriggerRange,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFChainingTriggerFeature,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableScopeActivity,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFScopeActivtyRestriction,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableADLSCosmosDataset,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataFlowExternalComputeInfo,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataMapperSaveFeature,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFCDC,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFCDCInitialLoad,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataflowEnableHive,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: __IS_A365__ ? GuardFeatures.ADFSynapseVNet : GuardFeatures.ADFVNet,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFOptionalPasswordToWebActivity,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_EnableFabricCapacityCreation,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADMSTrino,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFDataflowM365,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataFlowSchemaTimeoutForUX,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.ADFDataFlowConnectionTimeoutForUX,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.RerunRangeMaxAllowedFeatureName,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.ADFMaxTumblingWindowDependencyCount,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.ADFTumblingWindowTriggerValidateDependencySize,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ExpressionValidation,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_SupportSapTableRowSkips,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.UX_SsisIREnableVNetV2Feature,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFDataflowGoogleCloudStorageSource,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFUseSparkGatewayInAdf,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFSparkGatewayManagedVnet,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFSparkGatewayMultiRegion,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFSparkGatewayQuickReuse,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_EnableHdfsHttpfs,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.UX_EnableSsisIRSharing,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.UX_SupportSharePointOnlineFile,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFDataflowSwitchWarmpoolToReuse,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_SupportSapCdcConnector,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFDataflowOnPremOracle,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFIntegrationRuntimeAirflow,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFAirflowAutoscaleEnabled,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFAirflowAutoscaleUpdateEnabled,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableClearStorageForAirflowImport,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataFlowEnableCustomConfigurationFromIR,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataflowRemoveComputeTypeFromIR,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataflowCustomProperties,
        featureType: ExposureControlType.Dictionary
    },
    {
        featureName: GuardFeatures.ADFEnableEmailActivityInUI,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFDataflowSapOData,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_SsisIRSupportEvergreen,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFSupportLargeNumberOfActivities,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFMaxActivityCountWithLargeNumberOfActivities,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.UX_EnableADFLakehouseSchema,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFEnablePowerQueryActivityInADF,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_EnableWebhookOnIR,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFAzureDatabricksJobActivity,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.SupportTeradataSinkForNonFabricEnv,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFSupportTeradataSinkForNonFabricEnvUX,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_EnableSelectInServiceNowV2,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    }
];

export const tridentEcFeatures: IFeatureValue[] = [
    {
        featureName: GuardFeatures.ADFEnableScopeActivity,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFScopeActivtyRestriction,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableADLSCosmosDataset,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableDatabricksActivityInTrident,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableAzureDatabricksJobActivityInTrident,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableHDInsightActivityInTrident,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFSupportLargeNumberOfActivities,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFMaxActivityCountWithLargeNumberOfActivities,
        featureType: ExposureControlType.AllowList
    },
    {
        featureName: GuardFeatures.ADFTriggerVariablesInTridentUI,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UseTokenServiceInDFActivity,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.UseTokenServiceInDataflowActivity,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.EnableDFG21Param,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.UX_EnableFabricSql,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.ADFEnableWIForWebBasedActivities,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.ADFEnableCopyJobActivityInTrident,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.SupportExploratoryAPIForOAP,
        featureType: ExposureControlType.Feature,
        featureScope: 'ADMS'
    },
    {
        featureName: GuardFeatures.DbtJobLakehouseAdapter,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.DbtJobFabricSqlAdapter,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.EnableApiIntegrationActivity,
        featureType: ExposureControlType.Feature
    },
    {
        featureName: GuardFeatures.UX_EnableFabricActionPicker,
        featureType: ExposureControlType.Feature
    }
];
